/**
 * The routes that no longer exist, and where each one goes instead.
 *
 * 2026-09-07: /ai-receptionist, /crm, /missed-call-recovery and the four
 * /solutions/* pages became anchored sections of one /solutions page. A
 * retired route that only redirects inside React Router is not redirected at
 * all for a crawler that does not run JavaScript, so the same map has to reach
 * three places at once:
 *
 *   - src/App.tsx renders a <Navigate> per entry, for anyone who reaches the
 *     SPA shell first (the preview server, and any host that misses a rule)
 *   - public/_redirects, netlify.toml and vercel.json each carry a real 301
 *   - scripts/seo-baseline.cjs reads this module and fails the build if any of
 *     those three configs is missing an entry, has it twice, or has it after
 *     the SPA fallback
 *
 * Keep this a plain TypeScript module with no JSX and no runtime imports:
 * scripts/seo-baseline.cjs transpiles it in-process with esbuild and requires
 * it as CommonJS, the same way scripts/prerender.cjs reads src/data/pageSeo.ts.
 */
export type RetiredRoute = { from: string; to: string };

export const RETIRED_ROUTES: readonly RetiredRoute[] = [
  { from: "/ai-receptionist", to: "/solutions#ai-receptionist" },
  { from: "/crm", to: "/solutions#crm" },
  { from: "/missed-call-recovery", to: "/solutions#missed-call-recovery" },
  { from: "/solutions/ai-employee", to: "/solutions#ai-employee" },
  { from: "/solutions/crm", to: "/solutions#crm-calendar" },
  { from: "/solutions/websites", to: "/solutions#websites" },
  { from: "/solutions/workflows", to: "/solutions#workflows" },
  { from: "/blog/xh-auto-k2-website-implementation", to: "/blog/two-local-business-website-inquiry-flows" },
];
